import React from 'react';
export default function Loader({ text = 'Загрузка…' }) {
    return <div style={{ padding: 16, textAlign: 'center', opacity: 0.7 }}>{text}</div>;
}